import React from 'react';

/**
 * Data honesty badge (go-live-readiness.md §1/§5 criterion 2): every screen
 * shows real data or a CLEARLY-LABELED sample state — no silent mocks. The
 * visual language mirrors LogStreamPanel's feed badge (screens.css
 * .log-stream__feed): status-token color + letter-spaced caps, tokens only.
 *
 * mode 'live'   → "LIVE"  (data came from the backend)
 * mode 'sample' → label  (default; callers pass the honest reason)
 *
 * Place at feed/panel level where the scope is narrower than the page.
 */
function DataModeBadge({ mode = 'sample', label = null }) {
  if (mode === 'live') {
    return <span className="data-mode-badge data-mode-badge--live">LIVE</span>;
  }

  return (
    <span className="data-mode-badge data-mode-badge--sample">{label || 'Sample data'}</span>
  );
}

export default DataModeBadge;
